import StakeInput from './_stake-input.js'
import RemoveSelection from './_remove-selection.js'
import Odds from './_odds.js'
import BetErrors from './_bet-errors.js'

export default {
  name: 'CommonBetContent',
  values: {
    stakeInput: {
      configSet: StakeInput,
      configValues: {},
    },
    removeSelection: {
      configSet: RemoveSelection,
      configValues: {},
    },
    odds: {
      configSet: Odds,
      configValues: {},
    },
    betErrors: {
      configSet: BetErrors,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
